import { v4 as uuidv4 } from 'uuid';

// Create a configurable base URL
let BASE_URL = 'https://aiassistantretail.argevim.com.tr/api';

// Session ID that persists during the app lifecycle
let SESSION_ID = '';

// Initialize session ID on module load
const initializeSession = () => {
  SESSION_ID = uuidv4();
  console.log('Session initialized:', SESSION_ID);
  return SESSION_ID;
};

// Allow changing the base URL from the outside
export const setApiBaseUrl = (url) => {
  BASE_URL = url;
  console.log('API base URL set to:', BASE_URL);
};

// Get the current session ID
export const getSessionId = () => {
  return SESSION_ID || initializeSession();
};

// Upload file to API
export const uploadFile = async (file) => {
  const sessionId = getSessionId();
  const formData = new FormData();
  formData.append('file', file);
  
  try {
    const response = await fetch(`${BASE_URL}/upload`, {
      method: 'POST',
      headers: {
        'session-id': sessionId
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
};

// Analyze data and get insights (now with job-based approach)
export const startAnalysis = async (questions = [
  "Bölgelerin zamana göre performansını analiz et?",
  "Acentelerin zamana göre performansını analiz et?",
  "Ürünlerin zamana göre performansını analiz et?",
]) => {
  const sessionId = getSessionId();
  
  try {
    const response = await fetch(`${BASE_URL}/analyze`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'session-id': sessionId
      },
      body: JSON.stringify({ questions })
    });
    
    if (!response.ok) {
      throw new Error(`Analysis request failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json(); // Returns { job_id: "...", status: "pending" }
  } catch (error) {
    console.error('Analysis request error:', error);
    throw error;
  }
};

// Check the status of an analysis job
export const checkAnalysisResult = async (jobId) => {
  const sessionId = getSessionId();
  
  try {
    const response = await fetch(`${BASE_URL}/analyze/result?job_id=${jobId}`, {
      method: 'GET',
      headers: {
        'session-id': sessionId
      }
    });
    
    if (!response.ok) {
      throw new Error(`Job status check failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json(); // Returns { status: "pending"|"done", result: null|[...insights] }
  } catch (error) {
    console.error('Job status check error:', error);
    throw error;
  }
};

// Chat with AI about the data
export const chatWithAI = async (question) => {
  const sessionId = getSessionId();
  
  try {
    const response = await fetch(`${BASE_URL}/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'session-id': sessionId
      },
      body: JSON.stringify({ question })
    });
    
    if (!response.ok) {
      throw new Error(`Chat failed: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Chat error:', error);
    throw error;
  }
};

// Initialize session immediately when the module is imported
initializeSession();